import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { addProfesor } from "data/apiConection.js/dataProfesores"; // Actualiza la ruta según corresponda

const FormProfesor = ({ setFlagAddProfesor, flagAddProfesor }) => {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dni: "",
    sexo: "",
    birthDate: "",
    address: "",
    phone: "",
    email: ""
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const body = { ...formData };
      console.log(body);
      const response = await addProfesor(body); // Llama a la función para agregar un profesor
      if (response.message === "Profesor created successfully!") {
        setFlagAddProfesor(!flagAddProfesor);
      }
    }
    setValidated(true);
  };

  return (
    <Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro de Profesor</Card.Title>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="firstName">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nombre"
                value={formData.firstName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el nombre.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="lastName">
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Apellido"
                value={formData.lastName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el apellido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="dni">
              <Form.Label>DNI</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="DNI"
                value={formData.dni}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el DNI.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="sexo">
              <Form.Label>Sexo</Form.Label>
              <Form.Select
                required
                value={formData.sexo}
                onChange={handleInputChange}
              >
                <option value="">Seleccione</option>
                <option value="Masculino">Masculino</option>
                <option value="Femenino">Femenino</option>
                <option value="Otro">Otro</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Por favor, seleccione el sexo.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="birthDate">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                required
                type="date"
                value={formData.birthDate}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese una fecha válida.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="address">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Dirección"
                value={formData.address}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese la dirección.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="phone">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Teléfono"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el teléfono.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Correo Electrónico"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un correo válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="d-grid gap-2 mt-4">
            <Button type="submit" size="lg">
              Enviar Profesor
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

FormProfesor.propTypes = {
  setFlagAddProfesor: PropTypes.func,
  flagAddProfesor: PropTypes.bool
};

export default FormProfesor;
